var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAppReady
    ? _c(
        "div",
        { attrs: { id: "app" } },
        [_c("loader"), _c("header-wrapper"), _c("router-view")],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }